import { useTranslation } from "react-i18next";
import InvoiceRow from "./InvoiceRow";
import styles from "../styles/invoice.module.css";
import { useEsCliente } from "../../../../shared/hooks/useTenantTipo";

export default function TableBody({
  invoices,
  onEdit,
  onDelete,
  onEmail,
  selectedIds = new Set(),
  onToggleSelect,
}) {
  const { t } = useTranslation();
  const esCliente = useEsCliente();
  return (
    <div className={`${styles["table-body"]} ${styles["table-responsive"]}`}>
      <table>
        <thead>
          <tr>
            <th style={{ width: 36, paddingRight: 0 }}></th>
            <th>{t("facturas.colFactura")}</th>
            <th>{t("common.filial")}</th>
            {!esCliente && <th>{t("facturas.colPropietario")}</th>}
            <th>{t("facturas.colRubro")}</th>
            <th>{t("common.fecha")}</th>
            <th className={styles.monto}>{t("common.monto")}</th>
            <th className="text-center">{t("common.acciones")}</th>
          </tr>
        </thead>
        <tbody>
          {invoices.map((inv) => (
            <InvoiceRow
              key={inv.id_factura ?? inv.id}
              invoice={inv}
              onEdit={onEdit}
              onDelete={onDelete}
              onEmail={onEmail}
              selected={selectedIds.has(inv.id_factura ?? inv.id)}
              onToggleSelect={onToggleSelect}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
